import { put, takeLatest, select, call } from 'redux-saga/effects';
import { HttpMethod, HttpRequest } from '../../../shared/core/utils/requestHandler';
import { LOGIN_REQUESTING, LOGIN_SUCCESS, LOGIN_ERROR, LOGOUT_SUCCESSFUL, LOGOUT_ERROR, LOGOUT_REQUESTING } from '../../constants/shared/loginUserConstants';
import { SDV_401_MISSING_TOKEN } from '../../../shared/errors/ErrorMessages';
import { HOME_API_CALL_FAILURE } from '../../constants/shared/homeConstants'
import { con } from '../../../shared/config/config';

function getCurrentUser() {
    try {
        // Call the Express /current_user endpoint which:
        // 1. Reads req.user from the Hazelcast session (established by SsoAuthHandler)
        // 2. Enriches user_profile.roles (FOLLOW_UNFOLLOW, UPLOAD_FILES, DOWNGRADED_USER)
        // 3. Returns the enriched user data needed for component permission checks and consent flags
        const endpoint = `/current_user`;
        return new HttpRequest(HttpMethod.GET, endpoint, null, {}).invoke();
    } catch (error) {
        console.error('getCurrentUser error:', error);
        throw error;
    }
}

function* loginFlow(action) {
	try {
		console.log('loginFlow: Fetching enriched user profile via /current_user');
		const response = yield call(getCurrentUser);
		if (response.status === 200 && response.data !== null) {
			yield put({ type: LOGIN_SUCCESS, user: response.data.openid, exp: response.data.exp, user_profile: response.data.user_profile, sid: response.data.sid, discriminator: response.data.discriminator });
		}
	} catch (error) {
		console.log('loginFlow: /current_user returned error (likely 401 - no session), user needs to login');
		yield put({ type: LOGIN_ERROR, error });
	}
}

function* logoutFlow(action) {
	try {
		const getUser = (state) => state.login;
		let user = yield select(getUser);
		// If the token is already expired, skip /logout call — session is already
		// invalid server-side (token expiry check in /current_user destroys it).
		// Dispatch HOME_API_CALL_FAILURE so the UI shows the login screen.
		if (user.exp < Date.now() / 1000) {
			const error = { response: { data: { message: SDV_401_MISSING_TOKEN }, status: 401 } };
			yield put({ type: HOME_API_CALL_FAILURE, error });
		} else {
			// Always call server /logout to destroy the Hazelcast session,
			// regardless of whether this is an idle timeout or manual logout.
			// This ensures refreshing /login won't auto-authenticate the user.
			const savedRedirectionParams = sessionStorage.getItem('redirectionParams');
			const body = { 
				isTimeOut : action.isTimeOut,
				...(savedRedirectionParams != undefined && {redirectionParams: JSON.parse(savedRedirectionParams)})
			};
			const response = yield (new HttpRequest(HttpMethod.POST, `/logout`, null, body).invoke());
			if (response.status < 400) {
				console.debug("Logged Out", response);
				sessionStorage.removeItem('redirectionParams');
				yield put({ type: LOGOUT_SUCCESSFUL, response });
				//yield put({ type: LOGIN_UNSUCCESS, response });
			}
		}
	} catch (error) {
		console.error(error);
		sessionStorage.removeItem('redirectionParams');
		yield put({ type: LOGOUT_ERROR, error });
		// optionHandle('Log Out');
	}
}

function* loginWatcher() {
	yield takeLatest(LOGIN_REQUESTING, loginFlow);
	yield takeLatest(LOGOUT_REQUESTING, logoutFlow);
}

export default loginWatcher;
